/**
 * Infrastructure Element Colors — default color per mappable element type
 *
 * @module core/modules/infrastructure/constants/element-colors
 *
 * @description
 * Colores por defecto para los 6 tipos de elementos del módulo de infraestructura
 * que se representan en el mapa. El usuario puede personalizar cada color
 * desde el panel.
 */

/** The 6 infrastructure element types that have map representation */
export type InfrastructureElementId =
  | 'lighting'
  | 'traffic-lights'
  | 'furniture'
  | 'pavement'
  | 'networks'
  | 'drainage';

export const INFRASTRUCTURE_ELEMENT_COLORS: Record<InfrastructureElementId, string> = {
  'lighting':       '#fbbf24', // amarillo cálido (luminarias)
  'traffic-lights': '#ef4444', // rojo (semáforos)
  'furniture':      '#8b5cf6', // violeta (mobiliario)
  'pavement':       '#64748b', // gris (pavimentos)
  'networks':       '#06b6d4', // cyan (redes)
  'drainage':       '#0ea5e9', // azul claro (drenaje)
};

/** Set of IDs for quick lookup */
export const MAPPABLE_ELEMENT_IDS = new Set<string>(
  Object.keys(INFRASTRUCTURE_ELEMENT_COLORS),
);
